import { HttpGateways } from "@shared-kernel/secondary/http-gateway";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const ACCESS_TOKEN_COOKIE = "accessToken";
export const REFRESH_TOKEN_COOKIE = "refreshToken";

export const setAccessTokenCookie = (token: string, expiresIn: number) => {
  cookies.set(ACCESS_TOKEN_COOKIE, token, { path: "/", maxAge: expiresIn });
  HttpGateways.setBearerToken();
};

// The refresh token is rotated on every /refresh and lives longer than the access
// token (sliding TTL). Stored non-HttpOnly like the access token — same XSS
// exposure, no new pattern — and overwritten (with its refreshed lifetime) on each
// rotation. `expiresIn` comes from the server (refreshTokenExpiresIn) so the client
// never hardcodes the TTL rule.
export const setRefreshTokenCookie = (token: string, expiresIn: number) => {
  cookies.set(REFRESH_TOKEN_COOKIE, token, { path: "/", maxAge: expiresIn });
};

// Clears only the access token, keeping the refresh token. Used to end an
// impersonation session: dropping the impersonation access token lets the next
// request mint a fresh admin access token from the admin refresh token (which
// stayed in the cookie throughout impersonation).
export const clearAccessTokenCookie = () => {
  cookies.remove(ACCESS_TOKEN_COOKIE, { path: "/" });
  HttpGateways.setBearerToken();
};

// Clears every auth cookie. Used on logout / session termination.
export const clearAuthCookies = () => {
  cookies.remove(ACCESS_TOKEN_COOKIE, { path: "/" });
  cookies.remove(REFRESH_TOKEN_COOKIE, { path: "/" });
  HttpGateways.setBearerToken();
};

export const getAccessTokenCookie = (): string | null => {
  const token = cookies.get(ACCESS_TOKEN_COOKIE);
  return typeof token === "string" ? token : null;
};

export const getRefreshTokenCookie = (): string | null => {
  const token = cookies.get(REFRESH_TOKEN_COOKIE);
  return typeof token === "string" ? token : null;
};
